module.exports = __webpack_public_path__ + "img/swiper_nav1.57593ecc.png";